import { SxProps, TextField } from "@mui/material";
import { formatClockTimeInput } from "./formatClockTimeInput";

type Props = {
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
  disabled?: boolean;
  placeholder?: string;
  size?: "small" | "medium";
  sx?: SxProps;
  onBlur?: () => void;
};

const TimeField = ({
  value,
  onChange,
  error = false,
  disabled,
  placeholder,
  size = "small",
  sx,
  onBlur,
}: Props) => (
  <TextField
    autoComplete="off"
    disabled={disabled}
    error={error}
    inputProps={{ inputMode: "numeric", maxLength: 5 }}
    onBlur={onBlur}
    onChange={(event) => onChange(formatClockTimeInput(event.target.value))}
    placeholder={placeholder}
    size={size}
    sx={sx}
    value={value}
  />
);

export default TimeField;
